import { useEffect, useRef, useState } from 'react';
import { HiArrowLongLeft, HiArrowLongRight } from "react-icons/hi2";

const slidesData = [
    {
        id: 1,
        titleLight1: "The One ",
        titleBold1: "That",
        titleLight2: "suits",
        titleAccent: "Your Needs",
        subtitle1: "Dedicated to your health and hygiene",
        subtitle2: "Biodegradable cotton pads",
        badges: [
            { img: require('../assets/icons/BIS.png'), title: "BIS ISI Certified IS 5405: 2025", alt: "BIS ISI Certified" },
            { img: require('../assets/icons/Tested.png'), title: "Tested Phthalate Free", alt: "Tested Phthalate Free" },
            { img: require('../assets/icons/anti bacteria.png'), title: "Anti-Bacterial Tested", alt: "Anti-Bacterial" },
            { img: require('../assets/icons/NABL.png'), title: "NABL Accredited Lab ISO 17025", alt: "NABL Accredited Lab" }
        ],
        ctaText: "Read more",
        ctaLink: "#about-us",
        image: require('../assets/images/hero-banner.png'),
        imageAlt: "Fefine Cotton Sanitary Pads & Comfort"
    },
    {
        id: 2,
        titleLight1: "Pure Comfort ",
        titleBold1: "For",
        titleLight2: "Everyday",
        titleAccent: "Gentle Care",
        subtitle1: "100% Medical grade organic cotton protection",
        subtitle2: "Chemical & plastic free leak-lock design",
        badges: [
            { img: require('../assets/icons/BIS.png'), title: "BIS ISI Certified IS 5405: 2025", alt: "BIS ISI Certified" },
            { img: require('../assets/icons/Tested.png'), title: "Tested Phthalate Free", alt: "Tested Phthalate Free" },
            { img: require('../assets/icons/anti bacteria.png'), title: "Anti-Bacterial Tested", alt: "Anti-Bacterial" },
            { img: require('../assets/icons/NABL.png'), title: "NABL Accredited Lab ISO 17025", alt: "NABL Accredited Lab" }
        ],
        ctaText: "Read more",
        ctaLink: "#products",
        image: require('../assets/images/product-01.png'),
        imageAlt: "Fefine Premium Herbal & Cotton Pads"
    }
];

const Banner = () => {
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const timerRef = useRef(null);

    const totalSlides = slidesData.length;

    const nextSlide = () => {
        setActiveSlideIndex((prev) => (prev + 1) % totalSlides);
    };

    const prevSlide = () => {
        setActiveSlideIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
    };

    // Autoplay logic
    useEffect(() => {
        if (!isPaused) {
            timerRef.current = setInterval(() => {
                setActiveSlideIndex((prev) => (prev + 1) % totalSlides);
            }, 6000);
        }
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [isPaused, totalSlides]);

    return (
        <div
            className="hero-banner-section"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            <div className='hero-banner'>

                {/* Top-Right Fixed ISI Certification Badge */}
                <div className="banner-isi-badge" title="BIS Hygiene Verified IS:5405">
                    <img
                        src={require('../assets/icons/ISI.png')}
                        alt="IS: 5405 CM/L-7100076197 Hygiene Verified BIS-Govt. of India complied"
                        className="isi-badge-img"
                    />
                </div>

                <div className="w-100 banner-slider-wrapper">
                    <div className="container position-relative">
                        <div className="custom-slider-container">
                            {slidesData.map((slide, index) => {
                                const isActive = index === activeSlideIndex;
                                return (
                                    <div
                                        key={slide.id}
                                        className={`custom-slide-item ${isActive ? 'active-slide' : 'inactive-slide'}`}
                                        aria-hidden={!isActive}
                                    >
                                        <div className="row align-items-center">
                                            {/* Left Column: Text & Badges */}
                                            <div className="col-lg-7 pt-lg-3 banner-text-col">
                                                <h1 className='hero-heading slide-anim-item slide-delay-1'>
                                                    <span className='fw-normal'>{slide.titleLight1}</span>
                                                    <span className='fw-bold'>{slide.titleBold1}</span>
                                                    <br />
                                                    <span className='fw-normal'>{slide.titleLight2}</span>
                                                    <br />
                                                    <span className='fw-bold hero-heading-accent'>{slide.titleAccent}</span>
                                                </h1>

                                                <div className='hero-description slide-anim-item slide-delay-2'>
                                                    <p className='mb-1'>{slide.subtitle1}</p>
                                                    <p className='mb-0'>{slide.subtitle2}</p>
                                                </div>

                                                {/* 4 Feature / Certification Badges */}
                                                <div className="banner-badge-grid slide-anim-item slide-delay-3">
                                                    {slide.badges.map((badge, bIdx) => (
                                                        <div
                                                            key={bIdx}
                                                            className="banner-badge-card"
                                                            title={badge.title}
                                                        >
                                                            <img src={badge.img} alt={badge.alt} />
                                                        </div>
                                                    ))}
                                                </div>

                                                <div className="mt-4 slide-anim-item slide-delay-4">
                                                    <a href={slide.ctaLink} className='btn btn-hero-readmore'>
                                                        {slide.ctaText}
                                                    </a>
                                                </div>
                                            </div>

                                            {/* Right Column: Hero Product Image */}
                                            <div className="col-lg-5 banner-img-col">
                                                <div className="hero-img-wrapper slide-anim-item slide-delay-2">
                                                    <img
                                                        src={slide.image}
                                                        className='img-fluid hero-product-img'
                                                        alt={slide.imageAlt}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>

            {/* Slide Navigation and Counter in bottom white area */}
            <div className="container position-relative">
                <div className="banner-slide-controls">
                    <div className="slide-counter">
                        <span className="current-num">0{activeSlideIndex + 1}</span>
                        <span className="total-num">/ 0{totalSlides}</span>
                    </div>
                    <div className="slide-arrows">
                        <button
                            onClick={prevSlide}
                            className='btn-arrow-control'
                            aria-label="Previous slide"
                        >
                            <HiArrowLongLeft size={24} />
                        </button>
                        <span className="arrow-sep"></span>
                        <button
                            onClick={nextSlide}
                            className='btn-arrow-control'
                            aria-label="Next slide"
                        >
                            <HiArrowLongRight size={24} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
